<template>
  <div class="">
    <!-- <Header v-show="$route.meta.hasHeader" /> -->
    <div class="min-height mx-auto max-w-2xl">
      <keep-alive :include="$store.getters.keepAlives">
        <router-view />
      </keep-alive>
    </div>
    <Footer v-if="$route.meta.hasFooter" />
    <template v-if="$route.meta.hasTabbar">
      <Tabbar v-if="!isMiniapp" />
      <MiniTabbar v-else />
    </template>
  </div>
</template>

<script>
import Header from '@/layout/components/Header.vue'
import Footer from '@/layout/components/Footer.vue'
import Tabbar from '@/layout/components/Tabbar.vue'
import MiniTabbar from '@/layout/components/MiniTabbar.vue'
import { isWeChatApplet } from '@/utils/common'

export default {
  name: 'Layout',
  components: {
    Header,
    Footer,
    Tabbar,
    MiniTabbar,
  },
  data() {
    return {
      isMiniapp: false,
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
  },
  async created() {
    this.isMiniapp = await isWeChatApplet()
  },
}
</script>
<style scoped>
.min-height {
  min-height: calc(100vh - 100px);
}
</style>
